const SelectWrapper = ({ children }) => {
  return <div className="select__wrapper">{children}</div>;
};

export default SelectWrapper;
